module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.habilitarImpressaoBoleto && !_vm.descricaoLink) ? _c('v-btn', {
    attrs: {
      "color": "info",
      "fab": "",
      "small": "",
      "depressed": true,
      "title": "Imprimir Boleto"
    },
    on: {
      "click": _vm.imprimirPdf
    }
  }, [_c('i', {
    staticClass: "fas fa-print"
  })]) : _vm._e(), _vm._v(" "), (_vm.habilitarImpressaoBoleto && _vm.descricaoLink) ? _c('a', {
    attrs: {
      "href": "#",
      "title": "Imprimir Boleto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.imprimirPdf($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.descricaoLink))]) : _vm._e(), _vm._v(" "), (_vm.titulo.cod_boleto === null && !_vm.descricaoLink) ? _c('span', [_vm._v("\n        Boleto não disponível"), _c('br'), _vm._v("\n        Entre em contato com o setor financeiro\n    ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostrarModalPdf),
      callback: function($$v) {
        _vm.mostrarModalPdf = $$v
      },
      expression: "mostrarModalPdf"
    }
  }, [_c('v-card', {
    staticClass: "modal-pdf"
  }, [_c('v-card-text', [_c('iframe', {
    attrs: {
      "src": _vm.pdfBase64
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalPdf = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55923c9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/financeiro/components/ImprimirBoleto.vue
// module id = 544
// module chunks = 2